import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Axios from 'axios';
import { Typography, Grid, Paper } from '@material-ui/core';
import Auth from '../utils/Auth';
import VerticalList from '../utils/VerticalList';
import Style from '../utils/Style';
import ExplorerNavigationBar from '../explorer/ExplorerNavigationBar';

export default function Project() {
  const style = Style();
  const location = useLocation();
  const history = useHistory();
  const projectId = location.pathname.split('/')[2]; // Get project ID from URL
  const [state, setState] = useState({
    user: Auth.getUserID(),
    project: null,
    corrections: [] // Store corrections directly here
  });
  const [request, setRequest] = useState({ source: null, error: null });

  // Fetch project details
  const getProject = projectId => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/${state.user}/projects/${projectId}`;
    const source = Axios.CancelToken.source();

    Axios.get(url, { cancelToken: source.token })
      .then(response => {
        setState(prevState => ({
          ...prevState,
          project: response.data // Update project in state
        }));
        setRequest({ source: null, error: null });
      })
      .catch(error => {
        if (Axios.isCancel(error)) {
          setRequest({ source: null, error: null });
        } else {
          setRequest({ source: null, error: error });
        }
      });

    setRequest({ source: source, error: null });
  };

  // Fetch corrections for the project
  const getCorrections = projectId => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/${state.user}/projects/${projectId}/corrections`;
    const source = Axios.CancelToken.source();

    Axios.get(url, { cancelToken: source.token })
      .then(response => {
        setState(prevState => ({
          ...prevState,
          corrections: response.data // Update corrections in state
        }));
        setRequest({ source: null, error: null });
      })
      .catch(error => {
        if (Axios.isCancel(error)) {
          setRequest({ source: null, error: null });
        } else {
          setRequest({ source: null, error: error });
        }
      });

    setRequest({ source: source, error: null });
  };

  useEffect(() => {
    getProject(projectId); // Fetch project details
    getCorrections(projectId); // Fetch corrections for the project
  }, [projectId]);

  if (request.error) return <Typography color="error">Error loading project or corrections</Typography>;

  const verticalListData = () => {
    return {
      title: "Correcciones",
      items: state.corrections.map(correction => ({
        text: new Date(correction.date).toLocaleString(),
        action: () => history.push({
          pathname: `/projects/${projectId}/corrections/${correction.date}`,
          state: { projectName: state.project.name }
        })
      })),
      loading: request.source !== null // Indicate loading state
    };
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={style.paper}>
            <ExplorerNavigationBar
              style={style}
              data={{ init: "Proyectos", project: state.project }}
              actions={{
                selectInit: () => history.push('/projects'),
                selectProject: () => history.push(`/projects/${projectId}`),
                selectCorrection: () => { }
              }}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4}>
          <Paper className={style.paper}>
            <VerticalList {...verticalListData()} /> {/* Use VerticalList directly */}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}